const routes = [
    { name: 'home',                             path: '/' },
    { name: 'blog',                             path: '/blog', children: [
        { name: 'view',                         path: '/:slug' },
    ]},
    { name: 'pricing',                          path: '/pricing' },
    { name: 'pricingMemberships',               path: '/pricing/memberships' },
    { name: 'services',                         path: '/services', children: [
        { name: 'view',                         path: '/:service' },
    ]},
    { name: 'classes',                          path: '/classes' },
    { name: 'booking',                          path: '/booking' },
    { name: 'aboutUs',                          path: '/about-us' },
    { name: 'ourTeam',                          path: '/our-team' },
    { name: 'ourTeamMember',                    path: '/our-team/:member' },
    { name: 'contact',                          path: '/contact' },
    // Event Routes
    { name: 'events',                           path: '/events' },
    { name: 'eventsEvent',                      path: '/events/:event' },
    { name: 'eventsPast',                       path: '/events/past' },
    { name: 'eventsPastEvent',                  path: '/events/past/:event' },
    // { name: 'eventsPreTeenStretchStrengthen',   path: '/events/preteen-stretch-strengthen' },
    // { name: 'eventsPostNatalPilates',           path: '/events/post-natal-pilates' },
    // { name: 'eventsMammaBabyPostNatalPilates',  path: '/events/mamma-baby-post-natal-pilates' },
    { name: 'postNatal',                        path: '/post-natal' },
    { name: 'pilatesForRunners',                path: '/pilates-for-runners' },
    { name: 'restAndDigest',                    path: '/rest-and-digest' },

    { name: 'covidInformation',                 path: '/covid-information' },
    { name: 'virtualAppointments',              path: '/virtual-appointments' },
    { name: 'pursuitMovement',                  path: '/pursuit-movement' },
];

const redirects = {
    '/classes':         'https://clients.mindbodyonline.com/classic/ws?studioid=780573&stype=-7&sView=week&sLoc=0',
    '/booking':         'https://pursuithealth.janeapp.com/locations/pursuit-integrative-health/book',
};

export default routes;

export {
    redirects,
};

export function getRoute(routeKey, params = {}, attribute = 'path')
{
    const found = routes.find(route => route.name === routeKey);
    let routePath = found[attribute] || null;

    Object.keys(params).map((item, key) => {
        routePath = routePath.replace(`:${item}`, params[item]);
    });

    return routePath;
}

export function getSubRoute(routeKey, remove, params = {}, attribute = 'path')
{
    const routePath = getRoute(routeKey, params, attribute);

    const replace = `^${remove}`;
    const regExp = new RegExp(replace);

    return routePath.replace(regExp, '');
}
